import React, { lazy, Suspense, useCallback, useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import ActionDrawer from '../../../../components/CustomTableWithPagination/ActionDrawer';
import { useDispatch } from 'react-redux';
import ProfileViewAdmissionRegister from '../../../../components/datagrid/myworkspace/ogd/AdmissionRegister/ProfileViewAdmissionRegister';
import { Autocomplete, Box, Button, Grid, TextField, Tooltip, Typography } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import dayjs from 'dayjs';
import InduvidualAssessmentReport from '../../../assessmentReportInduvidual/InduvidualAssessmentReport';
import WhatsappShare from '../NewAdmissionRegister/WhatsappShare';
import SubjectAndTotalsession from '../NewAdmissionRegister/components/TotalSession';
import OGARemarks from '../NewAdmissionRegister/components/OGAremarks';
import Feepersession from '../NewAdmissionRegister/components/Feepersession';
import CourseCertificate from '../NewAdmissionRegister/components/CourseCertificate';
import Cronotes from '../NewAdmissionRegister/components/CROnotes';
import EvaluationTrackerLanding from '../NewAdmissionRegister/EvaluationTracker/EvaluationTrackerLanding';
import TerminationClearenceCRD from '../NewAdmissionRegister/components/TerminationClearence';
import SessionLogCRO from '../NewAdmissionRegister/components/SessionLogcro';
import SessionLog from '../NewAdmissionRegister/components/SessionLog';
import { useSelector } from 'react-redux';
import {
  getAdmissionRegisterDataForFinanceNewCustomTable,
  getAdmissionRegisterDataforPQANewCustomTable,
  getAllActiveCourses,
  getAllCroList,
  getCROlistUnderProject,
  getDataForCrdAdmissionRegisterForNewCustomTable,
} from '../../../../redux/features/CRDslice';
import { getClasses, getSubjects } from '../../../../redux/features/croSlice';
import { getProjectsPreData } from '../../../../redux/features/mastersSlice';
import { getCrolistunderCrm } from '../../../../redux/features/srtSlice';
import { New26AdmissionRegister } from '../../../../components/datagrid/CRD/NewAdmissionRegister/New26AdmissionRegister';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import AdmissionStatusCRM from '../NewAdmissionRegister/components/AdmissionStatusCRM';
import ViewTransactionHistory from '../NewAdmissionRegister/components/ViewTransactionHistory';
import StudentPortal from '../NewAdmissionRegister/components/StudentPortal';

// const AdmissionStatusCRM = lazy(() => import('../NewAdmissionRegister/components/AdmissionStatusCRM'));

const status = [
  { id: null, name: 'All' },
  { id: 1, name: 'Active' },
  { id: 0, name: 'Inactive' },
  { id: 2, name: 'Temporarly Inactive' },
];
const forecastTypes = [
  { id: null, name: 'All' },
  { id: 1, name: 'System' },
  { id: 2, name: 'Manual' },
];

const AdmissionRegisterCRD26 = ({ cro, crm, pqa, finance }) => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedYear, setSelectedYear] = useState(dayjs().format('YYYY'));
  const [selectedProjectId, setSelectedProjectId] = useState({
    id: null,
    name: 'All',
  });
  const [selectedCourseId, setSelectedCourseId] = useState({
    id: null,
    courseName: 'All',
  });
  const [selectedCroId, setSelectedCroId] = useState({
    userID: null,
    name: 'All',
  });
  const [selectedStatusId, setSelectedStatusId] = useState(1);
  const [selectedForecast, setSelectedForecast] = useState(null);
  const month = String(new Date().getMonth() + 1).padStart(2, '0');
  const mappingTrainerParams = new URLSearchParams({
    courseEnrollmentId: selectedRow?.course_enrollment_id,
    crm: crm ? 'true' : false,
    leadDetails: JSON.stringify(selectedRow),
  });
  const MappingTrainerEncoded = btoa(mappingTrainerParams.toString()); // base64 encoding

  const dispatch = useDispatch();
  const handleProjectChange = (e, option) => {
    setSelectedProjectId(option);
  };
  const handleCourseChange = (e, option) => {
    setSelectedCourseId(option);
  };
  const handleCroChange = (e, option) => {
    setSelectedCroId(option);
  };
  const handleStatusChange = (e, option) => {
    setSelectedStatusId(option?.id ?? null);
  };
  const handleType = (e, option) => {
    setSelectedForecast(option);
  };

  const {
    activeCourses,
    allcrolist,
    crosunderproject,
    admissionRegisterNewTableData,
    admissionRegisterNewTableDataLoading,
    loading,
  } = useSelector((store) => store.crd);
  const { loading: masterLoading, projectsPreData } = useSelector((state) => state.masters);
  const { loading: srtLoading, crolistundercrm } = useSelector((state) => state.srt);
  const filterLoading = masterLoading || srtLoading;
  const cred = JSON.parse(localStorage.getItem('cred'));
  const profile = cred.profile;
  const admissionRegisterTableState = cred?.tableState?.admissionRegisterTableState ?? {};

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getProjectsPreData());
      dispatch(getAllActiveCourses());
      dispatch(getSubjects());
      dispatch(getClasses());
      dispatch(getCrolistunderCrm({ crmId: null }));
      if (pqa) {
        dispatch(getCROlistUnderProject(profile?.departmentId));
      }
      if (finance) {
        dispatch(getAllCroList());
      }
    }, 4000);
    return () => clearTimeout(timeout);
  }, [pqa, finance]);

  const [actionDrawerOpen, setActionDrawerOpen] = useState(false);
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: admissionRegisterTableState?.frozenColumns || [],
    checkedRowIds: [],
    hiddenColumns: admissionRegisterTableState?.hiddenColumns || [],
  });

  useEffect(() => {
    localStorage.setItem(
      'cred',
      JSON.stringify({
        ...cred,
        tableState: {
          ...(cred.tableState || {}),
          admissionRegisterTableState: tableState,
        },
      }),
    );
  }, [tableState.frozenColumns, tableState.hiddenColumns]);

  const dispatchParams = useMemo(
    () => ({
      selectedYear,
      selectedProjectId,
      selectedCourseId,
      selectedCroId,
      selectedStatusId,
      page: tableState.page,
      limit: tableState.pageSize,
      search: tableState.search,
      sortKey: tableState.sort.field,
      sortDir: tableState.sort.direction,
      ...(pqa && { deptID: profile?.departmentId }),
      ...(finance && { typeID: selectedForecast?.id }),
    }),
    [
      selectedYear,
      selectedProjectId,
      selectedCourseId,
      selectedCroId,
      selectedStatusId,
      tableState.page,
      tableState.pageSize,
      tableState.search,
      tableState.sort.field,
      tableState.sort.direction,
      pqa,
      finance,
      selectedForecast?.id,
    ],
  );

  const apiToCall = useMemo(() => {
    if (pqa) {
      return getAdmissionRegisterDataforPQANewCustomTable;
    } else if (finance) {
      return getAdmissionRegisterDataForFinanceNewCustomTable;
    } else {
      return getDataForCrdAdmissionRegisterForNewCustomTable;
    }
  }, [pqa, finance]);

  const headers = New26AdmissionRegister(cro, crm, finance, dispatchParams, apiToCall);
  const croAutomcomplete = pqa ? crosunderproject : finance ? allcrolist : crolistundercrm;

  useEffect(() => {
    dispatch(apiToCall(dispatchParams));
  }, [dispatch, apiToCall, dispatchParams]);

  const hardRefreshParams = useMemo(() => ({ ...dispatchParams, hardRefresh: true }), [dispatchParams]);

  const handleRefresh = () => {
    dispatch(apiToCall(hardRefreshParams));
  };
  const handlenavigate = useCallback(() => {
    const url = `/my-workspace/student-attendance-view?admissionNo=${selectedRow?.admn_no}&studentName=${selectedRow?.student_name}&course=${selectedRow?.course_name}&courseEnrollmentId=${selectedRow?.course_enrollment_id}&total_sessions=${selectedRow.total_sessions}`;
    window.open(url, '_blank');
  }, [selectedRow]);

  const handlenavigateLedger = useCallback(() => {
    const url = `/my-workspace/ledger-view-cro?admissionNo=${selectedRow?.admn_no}&studentName=${selectedRow?.student_name}&course=${selectedRow?.course_name}&courseEnrollmentId=${selectedRow?.course_enrollment_id}`;
    window.open(url, '_blank');
  }, [selectedRow]);

  const actionListItems = [
    {
      label: selectedRow?.is_student_new ? 'Add Session Preference' : 'Update Expected Sessions',
      // showTooltip: selectedRow?.is_student_new ? 'Add Session Preference' : 'Update Expected Sessions',
      component: ({ row }) => {
        return (
          <Tooltip title={selectedRow?.is_student_new ? 'New Admission' : 'Old Admission'}>
            <span>
              <Button
                disabled={false}
                size="small"
                onClick={() => {
                  selectedRow?.is_student_new
                    ? window.open(
                        `/my-workspace/session-preference?courseenrollmentId=${selectedRow?.course_enrollment_id}&studentname=${selectedRow?.student_name}&phone=${selectedRow?.student_mob_no}&course=${selectedRow?.course_name}`,
                        '_blank',
                      )
                    : window.open(
                        `https://workspace.teaminterval.net/student/expected_sessions/-1/${selectedYear}/${month}`,
                        '_blank',
                      );
                }}
                variant="outlined"
              >
                <Icon
                  style={{ marginRight: '3px' }}
                  icon="material-symbols:right-click-rounded"
                  width="20"
                  height="20"
                />
                <Typography variant="button">Click</Typography>
              </Button>
            </span>
          </Tooltip>
        );
      },
    },
    {
      label: 'View ',
      component: ({ row }) => {
        return (
          <Tooltip title={selectedRow?.is_calendar_exists == 1 ? '' : 'Calendar Not Exist'}>
            <Box>
              <Button
                disabled={selectedRow?.is_calendar_exists != 1}
                sx={{
                  p: '7px',
                  px: '10px',
                  background: 'linear-gradient(135deg,rgb(7, 113, 219),rgba(4, 5, 5, 0.43))',
                  color: '#fff',
                  '&:hover': {
                    background: 'linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))',
                  },
                }}
                onClick={() => window.open(`/my-workspace/academic-calendar?leadId=${selectedRow?.lead_id}`, '_blank')}
                variant="outlined"
              >
                <Icon icon="mdi:eye" width="20" height="20" />
                Academic Calendar
              </Button>
            </Box>
          </Tooltip>
        );
      },
    },
    {
      label: 'Edit ',
      component: ({ row }) => {
        return (
          <Tooltip title={selectedRow?.is_calendar_exists == 1 ? '' : 'Calendar Not Exist'}>
            <Box>
              <Button
                disabled={selectedRow?.is_calendar_exists != 1}
                sx={{
                  p: '7px',
                  px: '29px',
                  background: 'linear-gradient(135deg,rgb(7, 113, 219),rgba(4, 5, 5, 0.43))',
                  color: '#fff',
                  '&:hover': {
                    background: 'linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))',
                  },
                }}
                onClick={() =>
                  window.open(`/my-workspace/academic-calendar-edit?leadId=${selectedRow?.lead_id}`, '_blank')
                }
                variant="outlined"
              >
                <Icon icon="mdi:eye" width="20" height="20" />
                Calendar Edit
              </Button>
            </Box>
          </Tooltip>
        );
      },
    },
    {
      label: 'View',
      component: ({ row }) => (
        <InduvidualAssessmentReport
          disabled={selectedRow?.assessment_report_file_exists != 1}
          sx={{
            p: '7px',
            pl: '10px',
            background: 'linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(160, 37, 194, 0.74))',
            color: '#fff',
            '&:hover': {
              background: 'linear-gradient(135deg, rgb(0, 49, 208), rgb(171, 37, 194))',
            },
          }}
          leadId={selectedRow?.lead_id}
          buttonName={'Assessment Report'}
          btnIcon={<Icon icon="mdi:eye" width="20" height="20" />}
        />
      ),
    },
    {
      label: 'Student Portal',
      component: () => <StudentPortal crm={crm} data={selectedRow} />,
    },
    {
      label: 'Student Track',
      component: () => {
        return (
          <Button
            size="small"
            onClick={() => window.open(`/my-workspace/studentTrack?leadId=${selectedRow?.lead_id}`, '_blank')}
            variant="outlined"
          >
            <Icon style={{ marginRight: '3px' }} icon="carbon:view" width="20" height="20" />
            <Typography variant="button">View</Typography>
          </Button>
        );
      },
    },
    { label: 'Whatsapp Share', component: () => <WhatsappShare rowData={selectedRow} /> },
    { label: 'Student Profile', component: () => <ProfileViewAdmissionRegister admNo={selectedRow?.admn_no} /> },

    {
      label: 'Edit ',
      component: ({ row }) => {
        return (
          <Tooltip title={'Student Edit'}>
            <span>
              <Button
                disabled={crm}
                size="small"
                onClick={() => window.open(`/my-workspace/student-edit/${selectedRow?.admn_no}`, '_blank')}
                variant="outlined"
              >
                <Icon
                  style={{ marginRight: '3px' }}
                  icon="material-symbols:right-click-rounded"
                  width="20"
                  height="20"
                />
                <Typography variant="button">Click</Typography>
              </Button>
            </span>
          </Tooltip>
        );
      },
    },
    {
      label: 'Total Sessions',
      component: () => (
        <SubjectAndTotalsession
          crm={crm}
          leadId={selectedRow?.lead_id}
          courseEnrollmentId={selectedRow?.course_enrollment_id}
          isDisable={!selectedRow?.total_sessions}
          dispatchParams={hardRefreshParams}
          apiCall={apiToCall}
        />
      ),
    },
    {
      label: 'OGA Remarks',
      component: () => <OGARemarks CROAssignID={selectedRow?.cro_assignment_id} />,
    },
    {
      label: 'Fee Per Session',
      component: () => (
        <Feepersession CourseEnrollId={selectedRow?.course_enrollment_id} isDisable={!selectedRow?.total_sessions} />
      ),
    },
    {
      label: 'Course Certificate',
      component: () => (
        <CourseCertificate
          apiCall={apiToCall}
          dispatchParams={hardRefreshParams}
          crm={crm}
          CourseEnrollmentId={selectedRow?.course_enrollment_id}
        />
      ),
    },
    {
      label: 'CRO Notes',
      component: () => (
        <Cronotes
          dispatchParams={hardRefreshParams}
          apiCall={apiToCall}
          crm={crm}
          data={selectedRow?.cro_notes}
          courseEnrollmentId={selectedRow?.course_enrollment_id}
        />
      ),
    },
    {
      label: 'CRO Tutor Mapping',
      component: () => (
        <Tooltip title={selectedRow?.is_subject_enrolled ? '' : 'Subject Not Enrolled'}>
          <span>
            <Button
              disabled={!selectedRow?.is_subject_enrolled}
              size="small"
              onClick={() => window.open(`/my-workspace/cro-trainer-mapping?data=${MappingTrainerEncoded}`, '_blank')}
              variant="outlined"
            >
              <Icon style={{ marginRight: '3px' }} icon="material-symbols:right-click-rounded" width="20" height="20" />
              <Typography variant="button">Click</Typography>
            </Button>
          </span>
        </Tooltip>
      ),
    },
    {
      label: 'Evaluation Tracker',
      component: () => <EvaluationTrackerLanding admissionNo={selectedRow?.admn_no} name={selectedRow?.student_name} />,
    },
    {
      label: 'Admission Status',
      component: () => <TerminationClearenceCRD crm={crm} CourseEnrollmentId={selectedRow?.course_enrollment_id} />,
    },
    {
      label: 'Session Log CRM',
      component: () => (
        <SessionLog crm={crm} rowData={selectedRow} courseEnrollmentId={selectedRow?.course_enrollment_id} />
      ),
    },
    {
      label: 'Session Log CRO',
      component: () => (
        <SessionLogCRO crm={crm} rowData={selectedRow} courseEnrollmentId={selectedRow?.course_enrollment_id} />
      ),
    },
    {
      label: 'Student Attendance',
      component: () => (
        <Button variant="outlined" size="small" color="primary" onClick={handlenavigate}>
          <Icon icon="mdi:eye" width="20" height="20" />
          View
        </Button>
      ),
    },
    {
      label: 'Ledger View',
      component: () => (
        <Button variant="outlined" size="small" color="primary" onClick={handlenavigateLedger}>
          <Icon icon="mdi:eye" width="20" height="20" />
          View
        </Button>
      ),
    },
  ];

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });

  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'Course Enrollment Status',
        title: 'Course Enrollment Status',
        maxWidth: 'md',
        render: ({ row }) => (
          // <Suspense fallback={<div style={{ padding: 20 }}>Loading...</div>}>
          <AdmissionStatusCRM
            status={row?.admission_status}
            id={row?.course_enrollment_id}
            dispatchParams={hardRefreshParams}
            setOpenModalComponentName={(value) => (!value ? setModalState({ actionKey: '', row: null }) : null)}
            dispatchFn={getDataForCrdAdmissionRegisterForNewCustomTable}
          />
          // </Suspense>
        ),
      },
      {
        actionKey: 'transaction_history',
        title: 'Transaction History',
        maxWidth: 'md',
        render: ({ row }) => (
          <ViewTransactionHistory
            id={row?.course_enrollment_id}
            setOpenModalComponentName={(value) => (!value ? setModalState({ actionKey: '', row: null }) : null)}
          />
        ),
      },
    ],
    [hardRefreshParams],
  );

  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    // console.log("action type",actionType);
    if (!actionKey || !row) return;
    else {
      setModalState({
        actionKey,
        row,
      });
    }
  }, []);

  const activeConfig = useMemo(() => {
    if (!Array.isArray(modalConfigs) || !modalState.actionKey || !modalState.row) return null;
    return modalConfigs.find((c) => c?.actionKey === modalState.actionKey) || null;
  }, [modalConfigs, modalState.actionKey, modalState.row]);

  const handleRowDrawer = useCallback((clickedRow) => {
    setSelectedRow(clickedRow);
    setActionDrawerOpen(true);
  }, []);

  return (
    <GlobalWrapper title="Admission Register">
      {/* FILTER SECTION */}
      <Box mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Autocomplete
              fullWidth
              name="projectId"
              options={[{ id: null, name: 'All' }, ...projectsPreData]}
              getOptionLabel={(option) => option.name || ''}
              value={selectedProjectId}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={handleProjectChange}
              renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Projects" />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Autocomplete
              fullWidth
              name="courseId"
              options={[{ id: null, courseName: 'All' }, ...activeCourses]}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) => option.courseName || ''}
              value={selectedCourseId}
              onChange={handleCourseChange}
              renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Courses" />}
            />
          </Grid>
          {crm || pqa || finance ? (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
              <Autocomplete
                fullWidth
                name="croId"
                options={[{ userID: null, name: 'All' }, ...croAutomcomplete]}
                getOptionLabel={(option) => option.name || ''}
                value={selectedCroId}
                onChange={handleCroChange}
                isOptionEqualToValue={(option, value) => option.userID === value.userID}
                renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="CRO" />}
              />
            </Grid>
          ) : null}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Autocomplete
              fullWidth
              name="statusId"
              options={status}
              getOptionLabel={(option) => option.name || ''}
              value={status?.find((status) => status?.id == selectedStatusId) || null}
              onChange={handleStatusChange}
              renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Status" />}
            />
          </Grid>
          {finance && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
              <Autocomplete
                fullWidth
                name="typeID"
                options={forecastTypes}
                getOptionLabel={(option) => option.name || ''}
                value={forecastTypes?.find((status) => status?.id == selectedForecast?.id) || null}
                onChange={handleType}
                renderInput={(params) => (
                  <TextField disabled fullWidth autoComplete="off" {...params} label="Forecast Type" />
                )}
              />
            </Grid>
          )}
        </Grid>
      </Box>
      {/* TABLE SECTION */}
      <GlobalTable
        headers={headers}
        rowUniqueId="sl_no"
        rows={Array.isArray(admissionRegisterNewTableData?.data) ? admissionRegisterNewTableData?.data : []}
        meta={admissionRegisterNewTableData?.meta}
        tableState={tableState}
        setTableState={setTableState}
        loading={admissionRegisterNewTableDataLoading}
        onButtonActionClick={handleButtonActionClick}
        actionDrawerRequired={true}
        onRowActionDrawerClick={handleRowDrawer}
        selectedRowUniqueId={actionDrawerOpen ? selectedRow?.sl_no : null}
        exportApi={apiToCall}
        exportParams={{ ...dispatchParams, page: 1, limit: 'no' }}
        showToolTip={'student_name'}
        checkboxNeeded={false}
        handleRefresh={handleRefresh}
      />
      <ActionDrawer
        drawerDisplayName={selectedRow?.student_name}
        open={actionDrawerOpen}
        row={selectedRow}
        actions={actionDrawerOpen ? actionListItems : []}
        onClose={() => {
          setActionDrawerOpen(false);
          setSelectedRow(null);
        }}
      />

      <Box>
        <GlobalDialog
          title={activeConfig?.title}
          open={Boolean(modalState?.actionKey)}
          setOpen={(val) => {
            if (!val) setModalState({ actionKey: '', row: null });
          }}
          closeButton={true}
          content={activeConfig?.render ? activeConfig.render({ row: modalState.row }) : null}
          maxWidth={activeConfig?.maxWidth || 'md'}
          fullWidth={true}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default AdmissionRegisterCRD26;
